import React from "react";
import { Redirect } from "react-router-dom";
import { useAuth } from "../context/AdminAuthContext";

const GuestRoute = ({ children }) => {

  const {
    isAuthenticated,
    loadingAuth
  } = useAuth();


  if (loadingAuth) {
    return <div>Loading...</div>;
  }


  // Already logged in
  if (isAuthenticated) {
    return <Redirect to="/home" />;
  }


  return children;
};


export default GuestRoute;